import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import { Link } from "react-router-dom";

const AvailableCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  return (
    <td {...props.tdProps}>
      <Link style={{ color: "#007bff" }} to={`/Assets/Vehicle/${props.dataItem.VehicleID}/ServiceStatuses`}>{props.dataItem.AvailableCityInfo}</Link>
      {props.dataItem.AvailableDateTime && <div style={{ fontSize: '11px' }}>{dayjs.utc(props.dataItem.AvailableDateTime).tz("America/New_York").format("MM/DD/YYYY HH:mm")}</div>}
    </td>
  );
}

export default React.memo(AvailableCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
